<template>
    <div class="update-profile-mission">
        <div class="box-point">
            <div class="text-get">{{lblMission.text_get}}</div>
            <div class="product-point">
                <div class="text">
                <span class="use-point">{{30 | number_format}}</span>
                    <span>
                        <img class="icon-point" src="@/assets/icon/reward_icon_coin@3x.png" />
                    </span>
                </div>
            </div>
        </div>
        <div class="text-fill-form">{{lblMission.text_fill}}</div>
        <div class="update-profile-form">
            <GenderRadio
                :isTitle="true"
                id='gender_radio'
                :inputId="'title'"
                :inputLbl='lblMission.form.title'
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="isShowErrorLbl"
                :errorInfo="errorInfo[0]"
                v-model="formRegister.title" 
                @input="onUpdateForm()"/>
            <TextInput
                inputId="firstname"
                :inputLbl="lblMission.form.firstname"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="isShowErrorLbl"
                :isTextOnly="true"
                :isRequired="isRequired"
                :errorInfo="errorInfo[1]"
                v-model="formRegister.firstName" 
                @input="onUpdateForm()"/>
            <TextInput
                inputId="lastname"
                :inputLbl="lblMission.form.lastname"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="isShowErrorLbl"
                :isTextOnly="true"
                :isRequired="isRequired"
                :errorInfo="errorInfo[2]"
                v-model="formRegister.lastName" 
                @input="onUpdateForm()"/>
            <GenderRadio
                :isGender="true"
                id='gender_radio'
                :inputId="'gender'"
                :inputLbl='lblMission.form.gender'
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[3]"
                v-model="formRegister.gender" 
                @input="onUpdateForm()"/>
            <DropdownDatePicker
                v-model="formRegister.birthDateformat"
                :formId="'formInfo'"
                :inputLbl="lblMission.form.birthdate"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="isShowBirthDateErrorLbl"
                :errorInfo="errorInfo[4]"
                :isRequired="isRequired"
                @onDateChange="onDatePickerSelected($event)"
                @onSelectDate="onSelectDate()"
            ></DropdownDatePicker>
            <TextInput
                inputId="contact-number"
                :inputLbl="lblMission.form.contactnumber"
                :isFirstSave="isFirstSave"
                :errorInfo="errorInfo[5]"
                :blockAutoComplete="true"
                :isMission="true"
                :isRequired="isRequired"
                v-model="formRegister.contactNumber" 
                v-if="isAccountLoaded"/>
            <Email
                inputId="email"
                :inputLbl="lblMission.form.email"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="isShowErrorLbl"
                :errorInfo="errorInfo[6]"
                :isRequired="isRequired"
                v-model="formRegister.email"
                @input="onUpdateForm()"/>
            <TextAreaInput
                addClass="register-info"
                inputId="register_address_input"
                :inputLbl="lblMission.form.shipping.address"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="isShowErrorLbl"
                :errorInfo="errorInfo[7]"
                :isRequired="isRequired"
                v-model="formRegister.address" 
                @input="onUpdateForm()"/>
            <FormAddressDropDown
                :formId="'formRegister'"
                :address="registerAddress"
                inputId="registerAddress"
                :lblShipping="lblMission.form.shipping"
                :zipcodeError="errorInfo[8]"
                :provinceError="errorInfo[9]"
                :districtError="errorInfo[10]"
                :subDistrictError="errorInfo[11]"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="isShowErrorLbl"
                :isRequired="isRequired" 
                @input="onUpdateForm()"/>

            <Button
                btnId="update_profile"
                :isBtnDisable="!isFormValid"
                :btnMsg="isHasExtensionJsonProperty ? lblMission.btn_submit : lbl.register.btn_next"
                @clickButton="clickSubmit()" />
        </div>
        <ModalMaster :controller="modalController" />
    </div>
</template>
<script>
//helper
import Util from '@/helper/Utility.js';
import FormHelper from '@/helper/FormHelper.js';
import Account from "@/helper/AccountHelper.js";
import CacheHelper from "@/helper/CacheHelper.js";
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
//component
import GenderRadio from '@/components/Input/GenderRadio.vue';
import TextInput from "@/components/Input/Text.vue";
import FormAddressDropDown from "@/components/Form/FormAddressDropDown.vue";
import DropdownDatePicker from '@/components/Input/DropdownDatePicker.vue';
import Email from '@/components/Input/Email.vue'
import TextAreaInput from '@/components/Input/TextAreaInput.vue';
import Button from '@/components/Button/Button.vue';
//service
import { AddressModel } from "@/core/Address/model/AddressModel.js";
//import { AddressParamsBuilder } from "@/core/Account/model/AccountModel.js";
export default {
    name: 'UpdateProfile',
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin, ModalMixin],
    components: {
        GenderRadio,
        TextInput,
        DropdownDatePicker,
        Email,
        TextAreaInput,
        FormAddressDropDown,
        Button
    },
    data: function() {
        return {
            token: null,
            errorInfo: [],
            isShowErrorLbl: true,
            isFirstSave: true,
            registerAddress: new AddressModel(),
            formRegister: {
                email: '',
                title: '',
                firstName: '',
                lastName: '',
                birthDate: '',
                birthDateformat: null,
                contactNumber: '',
                address: '',
                remark: 'mission_update_profile',
            },
            isRequired: true,
            lblMission: {},
            isShowBirthDateErrorLbl: false,
            isFormValid: false,
        };
    },
    computed: {
        isHasExtensionJsonProperty: function () {
            return this.profile && !Util.isEmptyStr(this.profile.extensionJsonProperty);
        },
    },
    created: function() {
        this.errorInfo = FormHelper.genErrorInfo(12);
        this.lblMission = this.lbl.mission.detail.update_profile;
    },
    methods: {
        setupModalCompleted: function(){
            this.initialOtherModal();
            console.log('mission', this.missionSuccessModal)
        },
        accountInitiated: function(){
            console.log('profile' , this.profile);
            this.initialPhone();  
        },
        initialPhone: function(){
            this.formRegister.contactNumber = Util.contactNumberFormat(this.profile.contactNumber, '-').slice(0, -4) + "xxxx";
            console.log('phone', this.formRegister.contactNumber);
        },
        clickSubmit: function(){
            const isBD = this.validateBD();
            const isEmail = this.validateEmail();
            if (this.isFormValid && isBD && isEmail) {
                this.registerAddress.address = this.formRegister.address;
                this.formRegister.contactNumber = this.profile.contactNumber;
                if (!this.isHasExtensionJsonProperty) {
                    const cache = new CacheHelper('session');
                    cache.setCache('profile', this.formRegister);
                    cache.setCache('profileAddress', this.registerAddress);
                    this.$router.push('/surveyeditprofile');
                } else {
                    this.createProfileModel();
                }
            }

            this.isFirstSave = false;
        },
        createProfileModel: function(){
            console.log('pro', this.formRegister);
            console.log('address', this.registerAddress)
            this.loadingModal.show();
            Account.apiUpdateProfile(this.formRegister, this.registerAddress)
                .then((res) => {
                    this.loadingModal.hide();
                    console.log('res', res);
                    this.checkBadge(res);

                }).catch(err => {
                    this.loadingModal.hide();
                    this.errorApi(err);
                });
        },
        checkBadge: function(res){
            if(res.objUser){
                if(res.objUser.buzzebees){
                    var badges = res.objUser.buzzebees.badges;
                    if (badges) {
                        console.log("badges", badges);

                        var mission_point = badges.filter(
                            o => o.id == "BiodermaUpdateProfile"
                        )[0];

                        if(mission_point && mission_point.points){
                            this.missionSuccessModal
                                .clearText()
                                .setPoint(mission_point.points)
                                .setTag('mission-update-profile')
                                .show();
                            
                            this.missionSuccessModal.onClickOk((data) =>{
                                if(data.tag == 'mission-update-profile'){
                                    this.getUserLastestPoint();
                                    this.$router.push('/mission');
                                }
                            });

                            this.missionSuccessModal.onClickPage((data) =>{
                                if(data.tag == 'mission-update-profile'){
                                    this.$router.push('/history/earn');
                                }
                            })
                        }
                    }
                }
            }
        },
        onDatePickerSelected: function(obj) {
            this.formRegister.birthDate = obj.timestamp;
            console.log(obj);
            this.onUpdateForm();
        },
        onSelectDate: function () {
            this.isSelectDate = true;
        },
        validateBD: function () {
            if (this.isSelectDate) { 
                if(this.errorInfo[4].isValid){
                    this.isShowBirthDateErrorLbl = false;
                    return true;
                }else{
                    this.isShowBirthDateErrorLbl = true;
                    return false;
                }
            }else{
                return true;
            }
        },
        validateEmail: function(){
            if (this.formRegister.email) { 
                if(this.errorInfo[6].isValid){
                    this.isShowEmailErrorLbl = false;
                    return true;
                }else{
                    this.isShowEmailErrorLbl = true;
                    return false;
                }
            }else{
                return true;
            }  
        },
        onUpdateForm: function(){ 
            let valid = FormHelper.validate(this.errorInfo);
            this.isFormValid = valid;
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import "@/style/input/BaseButton.scss";

.update-profile-mission{
    padding: 1.5em 0.5em 2em;

    .box-point{
        @extend %display-flex;
        width: fit-content;
        align-items: center;
        margin: auto;

        .text-get{
            font-family: $medium;
            font-size: 1.18rem;
            color: $blue-dark-gray;
            padding-right: 12px;
        }
        .product-point{
            flex: 0 0 80px;
            width: 80px;
            height: 33px;
            position: relative;
            font-size: 1.8rem;
            padding: 1px 4px 1px 12px;
            border-radius: 30px;
            background-color: $blue-gray;
            margin: auto;
            .text {
                @extend %display-flex;
                width: 100%;

                .use-point {
                    flex: 0 0 59%;
                    width: 59%;
                    margin-top: 8px;
                    font-family: $medium;
                    font-size: 1.12rem;
                    line-height: 1;
                    text-align: left;
                    color: $white;

                    @include mini-mobile() {
                        font-size: 1rem;
                    }
                }
                .icon-point {
                    flex: 0 0 35%;
                    width: 25px;
                    margin-top: -15px;

                    @include mini-mobile() {
                        flex: 0 0 43%;
                        width: 20px;
                    }
                }
            }
        }
    }
    .text-fill-form{
        color: $bright-gray;
        text-align: center;
        padding-top: 15px;
    }

    .btn-submit{
        @include btn-wrapper();
    }
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";
.update-profile-form{
    .wrap-input{
        margin-top: 25px;

        &.ddl-date-input{
            margin-top: 0;

            &.isSelected{
                .btn-ddl-input{
                    color: $bg-dark;
                }
            }
        }
        
        .ddl-input{
            &.isSelected{
                .btn-ddl-input{
                    color: $bg-dark;
                }
            }

            .btn-ddl-input{
                margin-top: 0;
            }
        }

        .label.error{
            color: $bright-gray;
        }
        .input-box{
            position: unset;

            .input-field{
                color: $bg-dark;
            }

            .error.input-field{
                border-color: $light-gray;
            }
        }
        .error-text{
            font-size: 1rem;
            color: $pink;
            text-align: left;
            margin-top: 5px;
        }

        #register_address_input{
            padding: 10px 25px;
        }
    }

    #gender_radio{
        .gender-col{
            margin-bottom: 0;
        }
    }
}
</style>